export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  // check

  return true
};

// ログイン後の戻り先 returnTo を検証する。URL のクエリから来る値なので、そのまま
// location.replace に渡すと外部サイトへのオープンリダイレクトや javascript: URL の
// 実行になる。同一オリジンの相対パス（"/" で始まり "//" で始まらない）だけを許し、
// それ以外は null を返す。
// ブラウザは URL 中のタブ・改行を捨て、"\" を "/" と読むため、"/\evil" や "/\t/evil" も
// "//evil" と同じになる。制御文字と "\" を含むものは弾く。
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001F\u007F]/;

export const safeReturnTo = (value) => {
  if (typeof value !== 'string') {
    return null;
  }
  if (!value.startsWith('/') || value.startsWith('//')) {
    return null;
  }
  if (value.includes('\\') || CONTROL_CHARS.test(value)) {
    return null;
  }
  try {
    if (new URL(value, window.location.origin).origin !== window.location.origin) {
      return null;
    }
  } catch (e) {
    return null;
  }
  return value;
};
